import LangEnum from '../../../lang/LangEnum';
import { ReferencePeriodEnum } from '../enums/referencePeriod.enum';

export const getReferencePeriodSelectLabel = (value: ReferencePeriodEnum) => {
  const mappedLabel: {
    [key in ReferencePeriodEnum]: { label: LangEnum; description: LangEnum };
  } = {
    [ReferencePeriodEnum.LAST_DAYS]: {
      label: LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_LAST_DAYS_OPTIONS_TITLE,
      description:
        LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_LAST_DAYS_OPTIONS_DESCRIPTIONS,
    },
    [ReferencePeriodEnum.CUSTOM_INTERVAL]: {
      label: LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_CUSTOM_INTERVAL_OPTIONS_TITLE,
      description:
        LangEnum.SELLOUT_GENERAL_SETTINGS_SELLOUT_PERIOD_SELECT_CUSTOM_INTERVAL_OPTIONS_DESCRIPTIONS,
    },
  };
  return mappedLabel[value];
};
